export class MediaService {
    static $inject = ['BlipService', 'AuthenticationService'];
    constructor(BlipService, AuthenticationService) {
        this.BlipService = BlipService;
        this.AuthenticationService = AuthenticationService;
    }
    async getMediaUploadUri(secure, profile) {
        await this.connectBlipClient();
        const uri = profile
            ? `/upload-media-uri?secure=${secure}&profile=${profile}`
            : `/upload-media-uri?secure=${secure}`;
        return await this.BlipService.processCommand({
            method: 'get',
            to: 'postmaster@media.msging.net',
            uri: uri,
        });
    }
    async connectBlipClient() {
        if (!(this.BlipService.isConnected())) {
            await this.BlipService.connect(encodeURIComponent(this.AuthenticationService.email), this.AuthenticationService.token);
        }
    }
}
MediaService.$inject = ['BlipService', 'AuthenticationService'];
